module.exports = __webpack_public_path__ + "img/GA.2a9abfb7.svg";